import { useState } from 'react';
import Modal from '../../../../../components/modals/Modal';
import QuestionIssues from '../../questions-summary-list/question-item/QuestionIssues';
import EditCard from '../EditCard';
import type { Question as IQuestion } from '../../../../../data/interface-question';

interface QuestionProps {
	question: IQuestion;
	onUpdate: (
		questionID: string,
		key: string,
		newValue: any
	) => Promise<IQuestion | null>;
}

const ViewEditIssues = ({ question, onUpdate }: QuestionProps) => {
	const [edit, setEdit] = useState(false);

	const handleUpdate = () => {
		onUpdate(question.id, 'issues', undefined)
			.then(() => setEdit(false))
			.catch((error) => console.error('Error updating question:', error));
	};

	if (question.issues === undefined) return null;
	return (
		<>
			<EditCard label='Issues' onEdit={setEdit}>
				<QuestionIssues issues={question.issues} />
			</EditCard>

			<Modal
				actionBtnText='Clear Issues'
				handleAction={handleUpdate}
				headline='Clear Issues'
				isOpen={edit}
				onClose={() => setEdit(false)}
				showCloseBtn={true}>
				{/* <button
					className='mb-4 text-sm text-white bg-red-500'
					onClick={() => setIssues(undefined)}>
					Clear Issues
				</button> */}
				<p>Para eliminar los issues, haz click abajo:</p>
			</Modal>
		</>
	);
};
export default ViewEditIssues;
